import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import projectColors from "../../../../theme/projectColors";
import MenuIcon from "@mui/icons-material/Menu";
import { useAppDispatch } from "../../../../redux/store";
import { openDrawer } from "../../../../redux/features/drawer/drawerSlice";

function HeaderMenu() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const dispatch = useAppDispatch();

  const openAppDrawer = () => {
    console.log("open");
    dispatch(openDrawer());
  };
  return (
    <Box
      bgcolor={projectColors.primary.light}
      borderRadius="0.5rem 0 0 0.5rem"
      minWidth={50}
      display={isSmallScreen ? "flex" : "none"}
      justifyContent="center"
      alignItems="center"
      alignContent="center"
    >
      <IconButton
        id="menu"
        aria-label="Abrir menú de navegación"
        onClick={openAppDrawer}
      >
        <MenuIcon sx={{ color: "white" }} />
      </IconButton>
    </Box>
  );
}

export default HeaderMenu;
